import { DocumentType } from "./enums/document.type";
import { User } from "./user";

export class ReportFile {
  ID: string;
  NAME: string;
  TYPE: ReportFileType;
  FILETYPE: string;
  SIZE: number;
  DOCUMENT_TYPE: DocumentType;
  PARENT_ID: string;
  UPLOADED_DATE: Date;
  UPLOADED_BY : User

  // Helper
  childrens: ReportFile[];
  SELECTED: boolean;
  FILE_DATA: any;

  constructor(value: any = {}) {
    Object.assign(this, value);

    if(!value.SIZE)
      this.SIZE = 0;

    if(value.childrens)
      this.childrens = ReportFile.parseArray(value.childrens);

      if(value.UPLOADED_BY)
      this.UPLOADED_BY = User.parse(value.UPLOADED_BY)
  }


  static parseArray(json: any[]): ReportFile[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(new ReportFile(j));

    return arr;
  }
}

export enum ReportFileType{
  FOLDER = 'FOLDER',
  FILE = 'FILE'
}
